// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import {
    getFirestore,
    enableIndexedDbPersistence,
    enableNetwork,
    disableNetwork
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage, ref } from 'firebase/storage';
import { getRemoteConfig } from 'firebase/remote-config';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import firebaseConfig from './config';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
auth.languageCode = localStorage.getItem('i18nextLng') || navigator.language;

const store = getFirestore(app);
const storage = getStorage(app);
const storageRef = ref(storage);
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(
        '6Ldw8gAhAAAAAPXQi7I1vEU7GaBs9O6DM76B35Uh'
    ),
    isTokenAutoRefreshEnabled: true
});

// enableIndexedDbPersistence(store)
//     .then((res) => console.log('Persistence enabled'))
//     .catch((err) => console.error('Error setting persistence. ', err));

// window.addEventListener(
//     'online',
//     async () => {
//         console.log('isOnline');
//         await enableNetwork(store);
//     },
//     false
// );

// window.addEventListener(
//     'offline',
//     async () => {
//         console.log('isOffline');
//         await disableNetwork(store);
//     },
//     false
// );

export { app, auth, store, storage, storageRef, remoteConfig };
